import { EmailNameFields } from './EmailNameFields';
import { RadioGroupField } from './RadioGroupField';
import { CheckboxGroupField } from './CheckboxGroupField';
import { TextareaField } from './TextareaField';

type SupportRequestFormFieldsProps = {
  formData: {
    email: string;
    name: string;
    primaryPerson: string;
    urgency: string;
    description: string;
    preferredService: string[];
    location: string;
  };
  onInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onRadioChange: (name: string, value: string) => void;
  onCheckboxChange: (name: string, value: string, checked: boolean) => void;
};

export const SupportRequestFormFields = ({
  formData,
  onInputChange,
  onRadioChange,
  onCheckboxChange,
}: SupportRequestFormFieldsProps) => {
  return (
    <>
      <EmailNameFields email={formData.email} name={formData.name} onChange={onInputChange} />

      <RadioGroupField
        label="Select the person connected to your client who requires support"
        name="primaryPerson"
        options={[
          'The Client',
          "Client's Spouse",
          "Client's Child",
          "Client's Parent",
          "Client's Grandparent",
          "Client's Sibling",
          'Other',
        ]}
        value={formData.primaryPerson}
        onChange={onRadioChange}
      />

      <RadioGroupField
        label="How urgent is the need for support?"
        name="urgency"
        options={[
          'Just gathering information for future planning',
          'Hoping to identify options in the next few weeks',
          'Actively looking—prefer to start within a few days',
          'Urgent—need support as soon as possible',
        ]}
        value={formData.urgency}
        onChange={onRadioChange}
      />

      <TextareaField
        id="description"
        name="description"
        label="Please provide a brief description of the support needed."
        value={formData.description}
        placeholder="Examples: dementia support, mobility assistance, personal care, companionship, medication management, transportation support, etc."
        rows={3}
        onChange={onInputChange}
      />

      <CheckboxGroupField
        label="Preferred service delivery method"
        name="preferredService"
        options={[
          'In-home (provider comes to the client)',
          'In-office (client travels to the provider)',
          'Virtual (phone or video call)',
        ]}
        values={formData.preferredService}
        onChange={onCheckboxChange}
      />

      <TextareaField
        id="location"
        name="location"
        label="Location where support is needed (City & ZIP code)"
        value={formData.location}
        placeholder="Enter the city and ZIP code where services will be provided."
        rows={2}
        onChange={onInputChange}
      />
    </>
  );
};

